import { ReactElement, ReactNode } from 'react';
import { toast, ToastOptions } from 'react-toastify';

const defaultOptions: ToastOptions = {
  position: toast.POSITION.TOP_CENTER,
  progress: 0,
};

/**
 * Shows a Success toast
 * @param {string} message text to show
 */
export const showSuccessToast = (
  message: ReactElement | ReactNode, options: ToastOptions = {},
): void => {
  toast.success(message, {
    ...defaultOptions,
    ...options,
    className: 'toast-success',
  });
};

/**
 * Shows a Error toast
 * @param {string} message text to show
 */
export const showErrorToast = (
  message: ReactElement | ReactNode, options: ToastOptions = {},
): void => {
  toast.error(message, {
    ...defaultOptions,
    ...options,
    className: 'toast-error',
  });
};

/**
 * Shows a Warning toast
 * @param {string} message text to show
 */
export const showWarningToast = (
  message: ReactElement | ReactNode, options: ToastOptions = {},
): void => {
  toast.warn(message, {
    ...defaultOptions,
    ...options,
    className: 'toast-warn',
  });
};

/**
 * Shows a Info toast
 * @param {string} message text to show
 */
export const showInfoToast = (
  message: ReactElement | ReactNode, options: ToastOptions = {},
): void => {
  toast.info(message, {
    ...defaultOptions,
    ...options,
    className: 'toast-info',
  });
};

/**
 * Shows a Default toast
 * @param {string} message text to show
 */
export const showDefaultToast = (
  message: ReactElement | ReactNode, options: ToastOptions = {},
): void => {
  toast(message, {
    ...defaultOptions,
    ...options,
    className: 'toast-default',
  });
};
